'use client';

import { AppErrorFallback } from '@/components/ErrorBoundary/AppErrorFallback';

type GlobalErrorPageProps = {
  error: Error & { digest?: string };
  reset: () => void;
};

export default function GlobalErrorPage({}: GlobalErrorPageProps) {
  return (
    <html lang="en">
      <body className="min-h-screen bg-gray-50">
        <AppErrorFallback
          title="We couldn't load this app"
          description="A technical issue prevented the app from rendering. Please try again."
          onAction={() => window.location.reload()}
          className="min-h-screen"
        />
      </body>
    </html>
  );
}
